import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "web-aadhaar-kyc",
    templateUrl: "./aadhaar-kyc.component.html",
    styleUrls: ["./aadhaar-kyc.component.scss"],
})
export class AadhaarKycComponent {
    constructor(private router: Router) {}

    aadhaarKyc() {
        this.router.navigate(["/loan/kyc-needed"]);
    }
}
